import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Minus } from 'lucide-react';
export function ComparisonTable() {
  return <section className="py-24 px-6 bg-white" data-id="element-11">
      <div className="max-w-5xl mx-auto" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900" data-id="element-14">
            Compara y decide
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="overflow-x-auto pb-6" data-id="element-15">
          <div className="min-w-[700px] bg-white rounded-2xl border border-gray-200 overflow-hidden" data-id="element-16">
            {/* Header */}
            <div className="grid grid-cols-4 bg-gray-50 border-b border-gray-200" data-id="element-17">
              <div className="p-6 font-medium text-gray-500" data-id="element-18"></div>
              <div className="p-6 font-bold text-gray-900 text-center" data-id="element-19">
                Solo
              </div>
              <div className="p-6 font-bold text-gray-900 text-center" data-id="element-20">
                Corredor
              </div>
              <div className="p-6 font-bold text-brand-700 text-center bg-brand-50 border-x border-brand-100" data-id="element-21">
                Con nosotros
              </div>
            </div>

            {/* Rows */}
            <div className="grid grid-cols-4 border-b border-gray-100" data-id="element-22">
              <div className="p-6 font-medium text-gray-900 flex items-center" data-id="element-23">
                Visibilidad
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center" data-id="element-24">
                Baja
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center" data-id="element-25">
                Alta
              </div>
              <div className="p-6 font-semibold text-brand-900 text-center bg-brand-50/50 border-x border-brand-100 flex items-center justify-center" data-id="element-26">
                Alta
              </div>
            </div>

            <div className="grid grid-cols-4 border-b border-gray-100" data-id="element-27">
              <div className="p-6 font-medium text-gray-900 flex items-center" data-id="element-28">
                Filtro de leads
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center" data-id="element-29">
                <X className="text-red-400" size={20} data-id="element-30" />
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center" data-id="element-31">
                Parcial
              </div>
              <div className="p-6 font-semibold text-brand-900 text-center bg-brand-50/50 border-x border-brand-100 flex items-center justify-center" data-id="element-32">
                <Check className="text-brand-600" size={20} data-id="element-33" />
              </div>
            </div>

            <div className="grid grid-cols-4 border-b border-gray-100" data-id="element-34">
              <div className="p-6 font-medium text-gray-900 flex items-center" data-id="element-35">
                Comisión
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center" data-id="element-36">
                0%
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center" data-id="element-37">
                2% + IVA
              </div>
              <div className="p-6 font-semibold text-brand-900 text-center bg-brand-50/50 border-x border-brand-100 flex items-center justify-center" data-id="element-38">
                Sin comisión (tarifa fija)
              </div>
            </div>

            <div className="grid grid-cols-4 border-b border-gray-100" data-id="element-39">
              <div className="p-6 font-medium text-gray-900 flex items-center" data-id="element-40">
                Control
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center" data-id="element-41">
                Total
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center" data-id="element-42">
                Bajo
              </div>
              <div className="p-6 font-semibold text-brand-900 text-center bg-brand-50/50 border-x border-brand-100 flex items-center justify-center" data-id="element-43">
                Total
              </div>
            </div>

            <div className="grid grid-cols-4" data-id="element-44">
              <div className="p-6 font-medium text-gray-900 flex items-center" data-id="element-45">
                Acompañamiento
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center" data-id="element-46">
                <X className="text-red-400" size={20} data-id="element-47" />
              </div>
              <div className="p-6 text-gray-600 text-center flex items-center justify-center text-sm" data-id="element-48">
                Sí, pero sin control
              </div>
              <div className="p-6 font-semibold text-brand-900 text-center bg-brand-50/50 border-x border-brand-100 flex items-center justify-center" data-id="element-49">
                Sí, paso a paso
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}